import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import CategoryNav from './components/CategoryNav';
import LatestGrid from './components/LatestGrid';
import CTASection from './components/CTASection';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '51暗网 - 每日吃瓜黑料实时追踪更新',
    description: '51暗网是专业的吃瓜黑料实时追踪平台，每日更新网红塌房、明星黑料、娱乐圈爆料等热门八卦内容。',
    url: 'http://chigualiao.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '51暗网',
      url: 'http://chigualiao.cn/',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://chigualiao.cn/',
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <PageMeta
        title="51暗网 | 每日吃瓜黑料实时追踪更新 - 网红明星爆料平台"
        description="51暗网是专业的吃瓜黑料实时追踪平台，每日更新网红塌房、明星黑料、娱乐圈爆料等热门八卦内容。提供51暗网app下载安装教程与最新地址入口。"
        keywords="51暗网app,51暗网下载,51暗网最新地址,吃瓜黑料,实时更新,网红爆料,51暗网入口,黑料大瓜"
        canonicalUrl="http://chigualiao.cn/"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedGrid />
        <CategoryNav />
        <LatestGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}